/* @flow */
/* eslint-env es6,browser */

import _adrenderbase from './adrenderbase';
import { cleanFrame } from '../utils/iframeutils';
import { logError, logDebug } from '../utils/logger';

/**
 * Provides interface for all ad servers and common functionality
 *
 * @class
 * @requires module:utils
 * @requires module:adloader
 * @requires module:logger
 */

class _appnexusRender extends _adrenderbase {
  constructor() {
    super('appnexusRenderer', 'appnexusAS');
  }

  /**
   * render the given ad using appNexus rendering
   *
   * @param {module:adloader.adInfo} adInfoObj - ad info object
   * @param {string} containerID - container ID to render into
   * @returns {boolean} - Ad is successfully rendered/not
   */
  renderAd(adInfoObj: adInfo, containerID: string = ''): boolean {
    const pos = adInfoObj.id || '';

    if (!pos.length || containerID.length === 0) {
      return false;
    }

    const div = this._doc.getElementById(containerID);
    if (!div) {
      return false;
    }
    // cleanup the container div
    cleanFrame(this._doc, div, '');
    try {
      logDebug(`${this._name} rendering ${pos} in ${containerID}`);
      const apn: apntagObj = this._win.apntag;
      apn.anq.push(() => {
        apn.showTag(containerID);
      });
    } catch (error) {
      logError(
        `${this._name} appnexus showTag failed for ${pos} ${error.message}`
      );
      return false;
    }
    return true;
  }
}
const appnexusRender = new _appnexusRender();

export default appnexusRender;
